var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.gotFeatured == false)?_c('FeaturedCarouselPlaceholder'):_vm._e(),(_vm.gotFeatured)?_c('FeaturedCarousel',{attrs:{"contents":_vm.contents}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }